import React from 'react'
import { NavLink } from 'react-router-dom'

import img1 from '../../Images/col_icon1.webp'
import img2 from '../../Images/col_icon2.webp'
import img3 from '../../Images/col_icon3.webp'
import img4 from '../../Images/col_icon4.webp'
import img5 from '../../Images/col_icon5.webp'
import img6 from '../../Images/col_icon6.webp'

const Studyabroad = () => {
    return (
        <div>


            <div className="container-fluid">
                <div className="row">
                    <div className="col p-0 m-0">
                        <div className='background_banner blog_banner'>
                            <h2>Find Study Abroad Universities</h2>
                            <p>Expert Counselling with 50% Off on Student Visa Fees, Choose from Extensive Colleges and Course options.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col text-center"> {/* Center content */}
                        <NavLink to="/contact" className='mybtn rounded-pill p-3'>Apply Now</NavLink>
                        <NavLink to="/contact" className='mybtn bg-primary rounded-pill  p-3 ms-2'>Shortlist College</NavLink>
                    </div>
                </div>



                <div className="container mt-5 pt-5">
                    <div className="row ">
                        <div className="col">
                            <div className='text-center'>
                                {/* heading */}
                                <h1 className='exploretitle fs-1'>
                                    Apply to 500+ Universities
                                </h1>

                                <p className='explore_para'>   Get Exclusive Discounts on Application & VISA Fees
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <div className="col">
                        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                            {/* Desktop Header */}
                            <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-wider bg-gray-50">
                                <div className="col-span-8">College</div>
                                <div className="col-span-2">Ranking</div>
                                <div className="col-span-2">Action</div>
                            </div>

                            {[
                                { img: img1, name: "Jawaharlal Nehru University - [JNU], New Delhi", rank: "1 out of 44" },
                                { img: img2, name: "Symbiosis International University - [SIU], Pune", rank: "1 out of 73" },
                                { img: img3, name: "Amity University, Noida", rank: "2 out of 73" },
                                { img: img4, name: "Delhi University - [DU], New Delhi", rank: "2 out of 44" },
                                { img: img5, name: "Aligarh Muslim University - [AMU], Aligarh", rank: "3 out of 44" },
                                { img: img6, name: "K L University - [KLU], Guntur", rank: "3 out of 73" }
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    {/* Mobile Card View */}
                                    <div className="md:hidden bg-white border-b border-gray-100 last:border-0 p-5 relative">
                                        <div className="flex items-start gap-4 mb-4">
                                            <img src={item.img} alt={item.name} className="w-16 h-16 rounded-lg object-contain border border-gray-100 bg-white flex-shrink-0" />
                                            <div>
                                                <h4 className="font-bold text-gray-900 text-sm mb-1">{item.name}</h4>
                                                <p className="text-xs text-gray-500 font-medium">Ranking: {item.rank}</p>
                                            </div>
                                        </div>
                                        <NavLink to="/contact" className="block w-full bg-brand-orange text-white text-center font-bold py-3 rounded-lg hover:bg-orange-600 transition text-sm">
                                            Apply Now
                                        </NavLink>
                                    </div>

                                    {/* Desktop Row View */}
                                    <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 hover:bg-orange-50/30 transition items-center">
                                        <div className="col-span-8 flex items-center gap-4">
                                            <img src={item.img} alt={item.name} className="w-12 h-12 rounded object-contain border border-gray-100 bg-white" />
                                            <span className="font-bold text-gray-800 text-sm">{item.name}</span>
                                        </div>
                                        <div className="col-span-2 text-sm text-gray-600">
                                            {item.rank}
                                        </div>
                                        <div className="col-span-2">
                                            <NavLink to="/contact" className="inline-block bg-brand-orange text-white text-xs font-bold px-6 py-2 rounded-lg hover:bg-orange-600 transition">
                                                Apply Now
                                            </NavLink>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Studyabroad
